// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"0dbdeeca","623":"5304c4d5"}[chunkId] + ".chunk.css";
};